import moment from "moment";
import axios from "axios";

const initialDocumentsFilterState = {
  year: moment().format('YYYY'),
  // year: 2023,
  appType: 'registering',
  appTypesAreConfigured: {},
  globalBudget: {},
  lastBudgetPerMonth: [],
  originalBudgetPerMonth: [],
  originalGlobalBudget: [],
  budgetPerMonth: [],
  followUp: [],
  originalFollowUp: [],
  lastMonthlyPremiumBudgetPerMonth: [],
  lastGlobalBudget: {},
  fetchBudgetData: {
    fetching: false,
    fetched: false,
    isError: false,
  },
  generateFollowUp: {
    processing: false,
    processed: false,
    isError: false,
  },
  updateFollowUp: {
    processing: false,
    processed: false,
    isError: false,
  },
  deleteBudgetConfiguration: {
    processing: false,
    processed: false,
    isError: false,
  },
  updateBudgetConfiguration: {
    processing: false,
    processed: false,
    isError: false,
  },
  isUpdatingFollowUp: false,
  isUpdatingSetUp: false,
  isUpdatingAnnualTarget: false,
  showTargetBudget: false,
  isDone: true,
  annualTargetId: null,
  isPositive: true,
  issuerId : null,
  recurrence_coefficient : 0,
  totalBudgetPerMonthPremiumMensuel: [],
};

const calculatePercentage = (lastBudgetPerMonth, totalHTVA) => {
  const lastTotalHTVA = lastBudgetPerMonth.reduce((acc, curr) => acc + curr.totalHTVA, 0);
  const percentage = lastTotalHTVA !== 0 && totalHTVA !== 0 ? ((totalHTVA - lastTotalHTVA) / lastTotalHTVA * 100).toFixed(1) : 100;
  return percentage;
}

const compareFollowUp = (followUp, budgetPerMonth) => {
  return followUp.map((followUpItem, index) => {
    const isPositive = followUpItem.realizedHTVA >= budgetPerMonth[index].totalHTVA;
    return {
      ...followUpItem,
      isPositive
    };
  });
};


export const budgetManagementReducer = (state = initialDocumentsFilterState, action) => {
  switch (action.type) {
    case "SET_BUDGET_TYPE_FILTER": {
      const {lastBudgetPerMonth} = state;
      return {...state, appType: action.payload, isUpdatingFollowUp: false, isUpdatingAnnualTarget: false};
    }
    case "SET_BUDGET_YEAR_FILTER": {
      return {...state, year: action.payload, isUpdatingFollowUp: false, appType: 'registering'};
    }
    case "SET_BUDGET_YEAR_RECCURENCE_COEFF": {
      const { lastBudgetPerMonth, lastGlobalBudget, budgetPerMonth, totalBudgetPerMonthPremiumMensuel } = state;
      const multiplyRegistrantsCount = (data, coefficient) => {
        let registrantCountUntilNov = 0;

        return data.map((item, i) => {
          let updatedRegistrantsCount = Math.floor(item.registrantsCount * coefficient);

          if (i < 11) {
            registrantCountUntilNov += updatedRegistrantsCount;
          }
          if (i === 11) {
            updatedRegistrantsCount = Math.floor((lastGlobalBudget.registrantsCount) * coefficient) - registrantCountUntilNov;
          }

          return {
            ...item,
            registrantsCount: updatedRegistrantsCount
          };
        });
      };

      const lastMonthlyPremiumBudgetPerMonth = multiplyRegistrantsCount(
        lastBudgetPerMonth,
        action.payload
      );
      let sum = 0;

      for (let i = 0; i < 12; i++) {
        if (budgetPerMonth[i].registrantsCount === '') {
          sum += 0;
        } else {
          sum += parseInt(budgetPerMonth[i].registrantsCount);
        }
        totalBudgetPerMonthPremiumMensuel[i] = sum;
      }

      return {
        ...state,
        recurrence_coefficient: action.payload,
        appType: 'monthly_premium',
        lastMonthlyPremiumBudgetPerMonth,
        totalBudgetPerMonthPremiumMensuel,
      };
    }
    case "SET_BUDGET_REGISTRANTS_COUNT": {
      const {pricePerUnit} = state.globalBudget;
      const registrantsCount = action.payload;
      let totalHTVA = 0;
      if (registrantsCount !== '') {
        totalHTVA = registrantsCount * pricePerUnit;
      }
      return {
        ...state,
        globalBudget: {...state.globalBudget, registrantsCount, totalHTVA},
        isUpdatingAnnualTarget: true,
      };
    }
    case "SET_PRICE_PER_UNIT": {
      let {registrantsCount} = state.globalBudget;
      let pricePerUnit = action.payload;
      let totalHTVA = 0;
      if (pricePerUnit !== '') {
        totalHTVA = registrantsCount * pricePerUnit;
      }
      return {
        ...state,
        globalBudget: {...state.globalBudget, pricePerUnit, totalHTVA},
        isUpdatingAnnualTarget: true,
      };

    }
    case "SET_SHOW_REALIZED_BUDGET": {
      return {...state, showTargetBudget: action.payload,};
    }
    case "SET_REGISTRANT_NUMBER": {
      return {...state, registrantNumber: action.payload,};
    }
    case "UPDATE_REGISTRANTS_COUNT_PER_MONTH": {
      const {pricePerUnit} = state.globalBudget;
      const {lastGlobalBudget, totalBudgetPerMonthPremiumMensuel} = state;
      const lastRegistrantsCount = state.lastBudgetPerMonth.reduce(
        (total, month) => total + Number(month.registrantsCount),
        0
      );

      let {index, value, appType} = action.payload;

      const {totalHTVA: lastTotalHTVA} = state.lastBudgetPerMonth[index];
      const updatedBudgetPerMonth = [...state.budgetPerMonth];
      updatedBudgetPerMonth[index] = {
        ...updatedBudgetPerMonth[index],
        registrantsCount: value,
        totalHTVA: value * pricePerUnit,
      };

      if (appType === 'monthly_premium' && value != null && value != 0) {

        for (let i = index + 1; i < updatedBudgetPerMonth.length; i++) {
          updatedBudgetPerMonth[i] = {
            ...updatedBudgetPerMonth[i],
            registrantsCount: value,
            totalHTVA: value * pricePerUnit,
          };
        }
      }

      const registrantsCount = updatedBudgetPerMonth.reduce(
        (total, month) => total + Number(month.registrantsCount),
        0
      );
      const totalHTVA = registrantsCount * pricePerUnit;
      const isPositive = updatedBudgetPerMonth[index].totalHTVA >= lastTotalHTVA;
      updatedBudgetPerMonth[index].isPositive = isPositive;
      const percentage = calculatePercentage(state.lastBudgetPerMonth, totalHTVA);
      const registrantsCountPercentage = lastRegistrantsCount !== 0 ? ((registrantsCount - lastGlobalBudget.registrantsCount) / lastGlobalBudget.registrantsCount * 100).toFixed(1): 100;

      let sum = 0;
      for (let i = 0; i < 12; i++) {
        if (updatedBudgetPerMonth[i].registrantsCount === '') {
          sum += 0;
        } else {
          sum += parseInt(updatedBudgetPerMonth[i].registrantsCount);
        }
        totalBudgetPerMonthPremiumMensuel[i] = sum;
      }


      return {
        ...state,
        globalBudget: {
          ...state.globalBudget,
          registrantsCount,
          totalHTVA,
          percentage,
          registrantsCountPercentage
        },
        budgetPerMonth: updatedBudgetPerMonth,
        totalBudgetPerMonthPremiumMensuel
      };
    }
    case "UPDATE_REGISTRANTS_COUNT_PER_REGISTRANT_COUNT": {
      const {pricePerUnit} = state.globalBudget;
      let {newRegistrantsCount, appType} = action.payload;
      const {lastGlobalBudget, recurrence_coefficient, totalBudgetPerMonthPremiumMensuel} = state;
      let registrantCountUntilNov = 0;

      if (newRegistrantsCount === '') {
        newRegistrantsCount = 0
      }

      const totalHTVA = newRegistrantsCount * pricePerUnit;

      // calculate total of registrantCount of last year
      const lastRegistrantsCount = state.lastBudgetPerMonth.reduce(
        (total, month) => total + Number(month.registrantsCount),
        0
      );

      const updatedBudgetPerMonth = state.lastBudgetPerMonth.map((budget, i) => {
        const registrantsCountPerMonth = budget.registrantsCount;
        let newRegistrantsCountPerMonth = lastRegistrantsCount !== 0 ? Math.floor(newRegistrantsCount * registrantsCountPerMonth / lastRegistrantsCount) : Math.floor(newRegistrantsCount/12);

        let newTotalHTVA = newRegistrantsCountPerMonth * pricePerUnit;
        if (i < 11) {
          registrantCountUntilNov += newRegistrantsCountPerMonth;
        }
        if (i === 11) {
          newRegistrantsCountPerMonth = newRegistrantsCount - registrantCountUntilNov;
          newTotalHTVA = newRegistrantsCountPerMonth * pricePerUnit;
        }

        const isPositive = newTotalHTVA >= budget.totalHTVA;
        return {
          ...budget,
          registrantsCount: newRegistrantsCountPerMonth,
          totalHTVA: newTotalHTVA,
          isPositive: isPositive,
          totalBudgetPerMonthPremiumMensuel,
        };
      });

      const percentage = calculatePercentage(state.lastBudgetPerMonth, totalHTVA);
      const registrantsCountPercentage = lastRegistrantsCount !== 0 ? ((newRegistrantsCount - lastGlobalBudget.registrantsCount) / lastGlobalBudget.registrantsCount * 100).toFixed(1) : 100;

      let sum = 0;
      for (let i = 0; i < 12; i++) {
        if (updatedBudgetPerMonth[i].registrantsCount === '') {
          sum += 0;
        } else {
          sum += parseInt(updatedBudgetPerMonth[i].registrantsCount);
        }
        totalBudgetPerMonthPremiumMensuel[i] = sum;
      }

      return {
        ...state,
        globalBudget: {
          ...state.globalBudget,
          lastRegistrantsCount,
          totalHTVA,
          percentage,
          registrantsCountPercentage
        },
        budgetPerMonth: updatedBudgetPerMonth,
      };
    }
    case "UPDATE_REGISTRANTS_COUNT_PER_PRICE": {
      // calculate total of registrantCount of last year
      const lastRegistrantsCount = state.lastBudgetPerMonth.reduce(
        (total, month) => total + Number(month.registrantsCount),
        0
      );

      let {newPricePerUnit} = action.payload;
      const {lastGlobalBudget} = state;
      const {registrantsCount: globalRegistrantsCount} = state.globalBudget;

      const totalHTVA = globalRegistrantsCount * newPricePerUnit;
      const updatedBudgetPerMonth = state.budgetPerMonth.map((budget, i) => {
        const {registrantsCount: budgetRegistrantsCount} = budget;
        const {totalHTVA: lastTotalHTVA} = state.lastBudgetPerMonth[i];
        let newTotalHTVA = budgetRegistrantsCount * newPricePerUnit;
        const isPositive = newTotalHTVA >= lastTotalHTVA;

        return {
          ...budget,
          registrantsCount: budgetRegistrantsCount,
          totalHTVA: newTotalHTVA,
          isPositive: isPositive,
        };
      });
      const lastPricePerUnit = lastGlobalBudget.pricePerUnit / 100;
      const percentage = calculatePercentage(state.lastBudgetPerMonth, totalHTVA);
      const percentagePricePerUnit = lastRegistrantsCount !== 0 ? ((newPricePerUnit - lastPricePerUnit) / lastPricePerUnit * 100).toFixed(1): 100;

      return {
        ...state,
        globalBudget: {...state.globalBudget, totalHTVA, percentage, percentagePricePerUnit},
        budgetPerMonth: updatedBudgetPerMonth,
      };
    }
    case "UPDATE_FOLLOW_UP_REGISTRANTS_COUNT_PER_MONTH": {
      const {pricePerUnit} = state.globalBudget;
      let {index, value} = action.payload;

      const updatedFollowUp = [...state.followUp];
      updatedFollowUp[index] = {
        ...updatedFollowUp[index],
        registrantsCount: value,
        totalHTVA: value * pricePerUnit,
      };
      return {
        ...state,
        followUp: updatedFollowUp,
        isUpdatingFollowUp: true,
      };
    }
    case "UPDATE_FOLLOW_UP_PRICE_PER_UNIT": {
      let {value} = action.payload;

      const updatedFollowUp = [...state.followUp];
      const currentMonth = new Date().getMonth() ;

      for(let i = currentMonth; i < updatedFollowUp.length; i++) {
        updatedFollowUp[i] = {
          ...updatedFollowUp[i],
          followUpPricePerUnit: value,
          totalHTVA: value * updatedFollowUp[i].registrantsCount,
        };
      }

      return {
        ...state,
        followUp: updatedFollowUp,
        isUpdatingFollowUp: true,
      };
    }
    case "SET_ORIGINAL_VALUES": {
      return {
        ...state,
        followUp: state.originalFollowUp,
        budgetPerMonth: state.originalBudgetPerMonth,
        globalBudget: state.originalGlobalBudget,
        isUpdatingFollowUp: false,
        isUpdatingSetUp: false,
      }
    }
    case "GET_DATA_TABLE_EVENT_STATS_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "GET_DATA_TABLE_EVENT_STATS_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }


    case "FETCH_BUDGET_DATA_PENDING": {
      const fetchBudgetData = {
        ...state.fetchBudgetData,
        fetched: false,
        fetching: true
      }
      return {...state, fetchBudgetData, isUpdatingSetUp: false, isUpdatingFollowUp: false};
    }
    case "FETCH_BUDGET_DATA_FULFILLED": {
      const fetchBudgetData = {
        ...state.fetchBudgetData,
        fetched: true,
        fetching: false,
        isError: false
      }


      const {data} = action.payload.data;
      const {globalBudget, budgetPerMonth, lastBudgetPerMonth, followUp, globalBudgetConfigurationId, lastGlobalBudget} = data;

      const lastRegistrantsCount = lastBudgetPerMonth.reduce(
        (total, month) => total + Number(month.registrantsCount),
        0
      );
      const updatedLastBudgetPerMonth = lastBudgetPerMonth.map((budget, i) => {
        budget.totalHTVA = budget.totalHTVA /100;
        return {
          ...budget,
        };
      });
      const updatedBudgetPerMonth = budgetPerMonth.map((budget, i) => {
        budget.totalHTVA = budget.totalHTVA /100;
        const isPositive = budget.totalHTVA >= updatedLastBudgetPerMonth[i].totalHTVA;
        return {
          ...budget,
          isPositive: isPositive,
        };
      });
      let updatedFollowUp = followUp.map((budget, i) => {
        budget.totalHTVA = budget.totalHTVA /100;
        budget.realizedHTVA = budget.realizedHTVA /100;
        budget.followUpPricePerUnit = budget.followUpPricePerUnit /100;
        return {
          ...budget,
        };
      });
      updatedFollowUp = compareFollowUp(updatedFollowUp, budgetPerMonth);
      globalBudget.totalHTVA = globalBudget.totalHTVA /100;
      globalBudget.pricePerUnit = globalBudget.pricePerUnit /100;
      globalBudget.percentage = calculatePercentage(lastBudgetPerMonth, globalBudget.totalHTVA);
      const lastPricePerUnit = lastGlobalBudget.pricePerUnit / 100;
      globalBudget.percentagePricePerUnit = lastRegistrantsCount !== 0 ? ((globalBudget.pricePerUnit - lastPricePerUnit) / lastPricePerUnit * 100).toFixed(1): 100;
      globalBudget.registrantsCountPercentage = lastRegistrantsCount !== 0 ? ((globalBudget.registrantsCount - lastGlobalBudget.registrantsCount) / lastGlobalBudget.registrantsCount * 100).toFixed(1) : 100;

      return {
        ...state,
        fetchBudgetData,
        globalBudget,
        originalGlobalBudget: globalBudget,
        budgetPerMonth: updatedBudgetPerMonth,
        originalBudgetPerMonth: updatedBudgetPerMonth,
        lastBudgetPerMonth: updatedLastBudgetPerMonth,
        followUp: updatedFollowUp,
        originalFollowUp: updatedFollowUp,
        annualTargetId: globalBudgetConfigurationId,
        lastGlobalBudget
      };

    }
    case "FETCH_BUDGET_DATA_REJECTED": {
      let error = action.payload;
      let fetchBudgetData = state.fetchBudgetData;
      if (!axios.isCancel(error)) {
        fetchBudgetData = {
          ...state.fetchBudgetData,
          fetching: false,
          isError: true
        };
      }
      return {
        ...state,
        fetchBudgetData,
      };
    }
    case "GENERATE_FOLLOW_UP_PENDING" : {
      const generateFollowUp = {
        ...state.generateFollowUp,
        processed: false,
        processing: true
      }
      return {...state, generateFollowUp};
    }
    case "GENERATE_FOLLOW_UP_FULFILLED" : {
      const generateFollowUp = {
        ...state.generateFollowUp,
        processed: true,
        processing: false,
        isError: false
      }
      const {data} = action.payload.data;
      const {globalBudgetConfigurationId, followUp} = data;
      const {appType} = state;

      let updatedFollowUp = followUp.map((budget, i) => {
        budget.totalHTVA = budget.totalHTVA /100;
        budget.realizedHTVA = budget.realizedHTVA /100;
        budget.followUpPricePerUnit = budget.followUpPricePerUnit /100;
        return {
          ...budget,
        };
      });
      updatedFollowUp = compareFollowUp(updatedFollowUp, state.budgetPerMonth);
      const appTypesAreConfigured = {...state.appTypesAreConfigured};
      appTypesAreConfigured[appType] = true;
      return {
        ...state,
        followUp: updatedFollowUp,
        annualTargetId: globalBudgetConfigurationId,
        generateFollowUp,
        originalFollowUp: updatedFollowUp,
        originalBudgetPerMonth: Object.assign({}, state.budgetPerMonth),
        appTypesAreConfigured
      }
    }
    case "GENERATE_FOLLOW_UP_REJECTED": {
      const generateFollowUp = {
        ...state.generateFollowUp,
        processing: false,
        isError: true
      };
      return {
        ...state,
        generateFollowUp,
      };
    }
    case "UPDATE_FOLLOW_UP_PENDING": {
      const updateFollowUp = {
        ...state.updateFollowUp,
        processed: false,
        processing: true
      }
      return {...state, updateFollowUp};
    }
    case "UPDATE_FOLLOW_UP_FULFILLED": {
      const updateFollowUp = {
        ...state.updateFollowUp,
        processed: true,
        processing: false,
        isError: false
      }

      return {
        ...state,
        updateFollowUp,
        isUpdatingFollowUp: false,
        originalFollowUp: state.followUp,
      }
    }
    case "UPDATE_FOLLOW_UP_REJECTED": {
      const updateFollowUp = {
      ...state.updateFollowUp,
      processing: false,
      isError: true
    };
      return {
        ...state,
        updateFollowUp,
      };
    }
    case "CHECK_APP_TYPES_CONFIGURATION_FULFILLED": {

      const {data} = action.payload.data;
      const appTypesAreConfigured = {
        'registering':  data[0].formation,
        'cycle': data[0].cycle,
        'all_in': data[0].season,
        'premium':  data[0].premium,
        'monthly_premium': data[0].monthly_premium,
        'congres':  data[0].congress,
        'cycle_essential':  data[0].cycle_essential
      }

       return {
          ...state,
         appTypesAreConfigured,
       }
    }
    case "DELETE_BUDGET_CONFIGURATION_PENDING": {
      const deleteBudgetConfiguration = {
        ...state.deleteBudgetConfiguration,
        processing: true,
        processed: false
      }
      return {...state, deleteBudgetConfiguration};
    }
    case "DELETE_BUDGET_CONFIGURATION_FULFILLED": {
      const deleteBudgetConfiguration = {
        ...state.deleteBudgetConfiguration,
        processed: true,
        processing: false,
        isError: false
      }

      const lastRegistrantsCount = state.lastBudgetPerMonth.reduce(
        (total, month) => total + Number(month.registrantsCount),
        0
      );

      const {data} = action.payload.data;
      const {globalBudget, budgetPerMonth, lastBudgetPerMonth, followUp, globalBudgetConfigurationId, lastGlobalBudget} = data;
      const {appType} = state;

      const updatedLastBudgetPerMonth = lastBudgetPerMonth.map((budget, i) => {
        budget.totalHTVA = budget.totalHTVA /100;
        return {
          ...budget,
        };
      });
      const updatedBudgetPerMonth = budgetPerMonth.map((budget, i) => {
        budget.totalHTVA = budget.totalHTVA /100;
        const isPositive = budget.totalHTVA >= updatedLastBudgetPerMonth[i].totalHTVA;
        return {
          ...budget,
          isPositive: isPositive,
        };
      });
      let updatedFollowUp = followUp.map((budget, i) => {
        budget.totalHTVA = budget.totalHTVA /100;
        budget.realizedHTVA = budget.realizedHTVA /100;
        budget.followUpPricePerUnit = budget.followUpPricePerUnit /100;
        return {
          ...budget,
        };
      });
      updatedFollowUp = compareFollowUp(updatedFollowUp, budgetPerMonth);
      globalBudget.totalHTVA = globalBudget.totalHTVA /100;
      globalBudget.pricePerUnit = globalBudget.pricePerUnit /100;
      globalBudget.percentage = calculatePercentage(lastBudgetPerMonth, globalBudget.totalHTVA);
      const lastPricePerUnit = lastGlobalBudget.pricePerUnit / 100;
      globalBudget.percentagePricePerUnit = lastRegistrantsCount !== 0 ? ((globalBudget.pricePerUnit - lastPricePerUnit) / lastPricePerUnit * 100).toFixed(1) : 100;
      globalBudget.registrantsCountPercentage = lastRegistrantsCount !== 0 ? ((globalBudget.registrantsCount - lastGlobalBudget.registrantsCount) / lastGlobalBudget.registrantsCount * 100).toFixed(1): 100;

      const appTypesAreConfigured = {...state.appTypesAreConfigured};
      appTypesAreConfigured[appType] = false;

      return {
        ...state,
        deleteBudgetConfiguration,
        globalBudget,
        budgetPerMonth: updatedBudgetPerMonth,
        originalBudgetPerMonth: updatedBudgetPerMonth,
        lastBudgetPerMonth: updatedLastBudgetPerMonth,
        followUp: updatedFollowUp,
        originalFollowUp: updatedFollowUp,
        annualTargetId: globalBudgetConfigurationId,
        lastGlobalBudget,
        appTypesAreConfigured
      };

    }

    case "DELETE_BUDGET_CONFIGURATION_REJECTED": {
      const deleteBudgetConfiguration = {
        ...state.deleteBudgetConfiguration,
        processing: false,
        isError: true
      };
      return {
        ...state,
        deleteBudgetConfiguration,
      };
    }

    case "UPDATE_SET_UP": {
      return {...state,  isUpdatingSetUp: true};
    }

    case "UPDATE_CONFIGURATION_PENDING": {
      const updateBudgetConfiguration = {
        ...state.updateBudgetConfiguration,
        processing: true,
        processed: false
      }
      return {...state, updateBudgetConfiguration};
    }

    case "UPDATE_CONFIGURATION_FULFILLED": {
      const updateBudgetConfiguration = {
        ...state.updateBudgetConfiguration,
        processed: true,
        processing: false,
        isError: false
      }

      return {
        ...state,
        isUpdatingSetUp: false,
        isUpdatingFollowUp: false,
        updateBudgetConfiguration,
        originalFollowUp: state.followUp,
        originalBudgetPerMonth: state.budgetPerMonth,
        originalGlobalBudget: state.globalBudget,
      };
    }

    case "UPDATE_CONFIGURATION_REJECTED": {
      const updateBudgetConfiguration = {
        ...state.updateBudgetConfiguration,
        processing: false,
        isError: true
      };
      return {
        ...state,
        updateBudgetConfiguration,
      };
    }

    default:
      return state;
  }
};





// WEBPACK FOOTER //
// ./app/reducers/index/EventStats/BudgetManagement/budgetManagementReducer.js